import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    personLastName?: ?string;
}

export class TimesheetEntryPersonLastName extends React.PureComponent<Props> {
    render() {
        const { personLastName } = this.props;
        if (!personLastName) return null;
        return personLastName;
    }
}

const mapStateToProps = createStructuredSelector({
    personLastName: makeSelectTimesheetEntryValue('personLastName')
});

export default connect(mapStateToProps)(TimesheetEntryPersonLastName);
